import styled from 'styled-components';

export const ErrorMessage = styled.div`
    background-color: #ee7777;
    border-radius: 8px;
    color: #fff;
    padding: 16px;
    text-align: center;
    width: 100%;
`;